var map = {
	"./WildfaceChart.svg": 1554,
	"./beweegtable.svg": 5964,
	"./bweeg1.svg": 7661,
	"./bweeg2.svg": 9199,
	"./bweegchart.svg": 4910,
	"./circle.svg": 4458,
	"./table1.svg": 2995,
	"./table2.svg": 1791,
	"./table3.svg": 6808,
	"./wildface1.svg": 4558,
	"./wildface2.svg": 610,
	"./wildface3.svg": 8916,
	"./wildface4.svg": 7738,
	"./wildface6.svg": 8045
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4137;